import style from "./CardContainer.module.scss"

export function CardContainer({children}) {
    return(
        <div className={style.container}>{children}</div>
    )
}